import PropTypes from 'prop-types';
import React from 'react';

const CleaningIncluded = ({ color = '#224251', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3445_71)">
      <path d="M3.26241 4.68945L15.3471 4.68945L17.8381 10.2575L0.771438 10.2575L3.26241 4.68945Z" stroke={color} />
      <mask id="path-2-inside-1_3445_71" fill="white">
        <rect x="4.22223" y="2" width="4.22222" height="3.16667" rx="0.4" />
      </mask>
      <rect
        x="4.22223"
        y="2"
        width="4.22222"
        height="3.16667"
        rx="0.4"
        stroke={color}
        strokeWidth="1.6"
        mask="url(#path-2-inside-1_3445_71)"
      />
      <path
        d="M13.2268 8.61896C13.2803 8.65708 13.3443 8.67755 13.41 8.67749C13.4756 8.67742 13.5396 8.65684 13.593 8.61862C13.6463 8.57874 13.6869 8.52415 13.7097 8.46156L13.8284 8.09647C13.8569 8.01045 13.9051 7.93228 13.9691 7.86818C14.0331 7.80408 14.1113 7.75582 14.1973 7.72726L14.5689 7.60648C14.6312 7.58413 14.6849 7.54276 14.7224 7.48821C14.76 7.43367 14.7794 7.36871 14.778 7.30253C14.7766 7.23634 14.7544 7.17226 14.7146 7.11935C14.6748 7.06644 14.6194 7.02738 14.5562 7.00768L14.1904 6.88929C14.1043 6.86086 14.0261 6.8127 13.9619 6.74865C13.8978 6.68461 13.8495 6.60646 13.8209 6.52043L13.7001 6.14952C13.6782 6.08827 13.6378 6.03532 13.5846 5.99794C13.5313 5.96056 13.4678 5.9406 13.4027 5.9408C13.3367 5.94052 13.2723 5.96098 13.2186 5.99929C13.1649 6.03761 13.1246 6.09183 13.1033 6.15431L12.9815 6.52728C12.9529 6.61075 12.9058 6.68668 12.8437 6.74937C12.7816 6.81206 12.7061 6.8599 12.6229 6.88929L12.252 7.00939C12.19 7.03129 12.1364 7.07197 12.0987 7.12577C12.0609 7.17957 12.0409 7.2438 12.0414 7.30952C12.0419 7.37524 12.0629 7.43917 12.1014 7.4924C12.14 7.54563 12.1941 7.58551 12.2564 7.60648L12.6215 7.72521C12.7077 7.75401 12.786 7.80249 12.8502 7.86681C12.9144 7.93114 12.9628 8.00953 12.9914 8.09578L13.1119 8.46532C13.1334 8.52691 13.1735 8.58098 13.2268 8.61896ZM12.728 7.39844L12.4354 7.30776L12.731 7.21162C12.866 7.1651 12.9884 7.08791 13.0886 6.98613C13.1885 6.88347 13.2638 6.76029 13.309 6.62479L13.3996 6.33087L13.4955 6.62582C13.5408 6.76273 13.6176 6.88712 13.7197 6.98902C13.8218 7.09092 13.9463 7.16751 14.0833 7.21264L14.3844 7.30469L14.0902 7.40049C13.9531 7.44573 13.8285 7.52247 13.7264 7.62456C13.6243 7.72665 13.5475 7.85124 13.5023 7.98834L13.4116 8.28158L13.3162 7.98765C13.271 7.85033 13.1943 7.7255 13.0921 7.62323C12.99 7.52095 12.8652 7.44373 12.728 7.39844Z"
        fill={color}
      />
      <path
        d="M11.7125 15.6132C11.7767 15.659 11.8535 15.6835 11.9323 15.6834C12.0111 15.6834 12.0878 15.6587 12.1519 15.6128C12.2159 15.5649 12.2646 15.4994 12.2919 15.4243L12.4344 14.9862C12.4686 14.883 12.5264 14.7892 12.6032 14.7123C12.6801 14.6354 12.7738 14.5774 12.877 14.5432L13.323 14.3982C13.3978 14.3714 13.4622 14.3218 13.5072 14.2563C13.5523 14.1909 13.5756 14.1129 13.5739 14.0335C13.5722 13.9541 13.5456 13.8772 13.4979 13.8137C13.4501 13.7502 13.3836 13.7033 13.3078 13.6797L12.8688 13.5376C12.7655 13.5035 12.6716 13.4457 12.5946 13.3688C12.5176 13.292 12.4597 13.1982 12.4254 13.095L12.2804 12.6499C12.2541 12.5764 12.2057 12.5128 12.1418 12.468C12.0779 12.4231 12.0017 12.3992 11.9236 12.3994C11.8444 12.3991 11.7671 12.4236 11.7026 12.4696C11.6382 12.5156 11.5898 12.5807 11.5643 12.6556L11.4181 13.1032C11.3838 13.2034 11.3273 13.2945 11.2527 13.3697C11.1782 13.4449 11.0876 13.5023 10.9878 13.5376L10.5427 13.6817C10.4683 13.708 10.404 13.7568 10.3587 13.8214C10.3134 13.8859 10.2894 13.963 10.29 14.0419C10.2906 14.1207 10.3158 14.1975 10.362 14.2613C10.4083 14.3252 10.4733 14.3731 10.548 14.3982L10.9862 14.5407C11.0896 14.5753 11.1836 14.6334 11.2606 14.7106C11.3377 14.7878 11.3957 14.8819 11.43 14.9854L11.5746 15.4288C11.6004 15.5028 11.6485 15.5676 11.7125 15.6132ZM11.1139 14.1486L10.7628 14.0398L11.1176 13.9244C11.2796 13.8686 11.4265 13.776 11.5466 13.6538C11.6665 13.5306 11.7569 13.3828 11.8111 13.2202L11.9199 12.8675L12.0349 13.2214C12.0893 13.3857 12.1815 13.535 12.304 13.6573C12.4265 13.7796 12.5759 13.8715 12.7403 13.9256L13.1016 14.0361L12.7485 14.1511C12.584 14.2053 12.4345 14.2974 12.312 14.4199C12.1895 14.5424 12.0974 14.6919 12.0431 14.8565L11.9343 15.2084L11.8197 14.8556C11.7655 14.6909 11.6735 14.5411 11.5509 14.4183C11.4283 14.2956 11.2786 14.2029 11.1139 14.1486Z"
        fill={color}
      />
      <path
        d="M21.1267 16.1606C21.1909 16.2063 21.2677 16.2309 21.3465 16.2308C21.4252 16.2307 21.502 16.206 21.5661 16.1602C21.6301 16.1123 21.6788 16.0468 21.7061 15.9717L21.8486 15.5336C21.8828 15.4304 21.9406 15.3366 22.0174 15.2596C22.0943 15.1827 22.188 15.1248 22.2912 15.0905L22.7372 14.9456C22.8119 14.9188 22.8764 14.8691 22.9214 14.8037C22.9665 14.7382 22.9898 14.6603 22.9881 14.5809C22.9864 14.5014 22.9598 14.4245 22.9121 14.361C22.8643 14.2976 22.7978 14.2507 22.722 14.227L22.283 14.085C22.1797 14.0509 22.0858 13.9931 22.0088 13.9162C21.9318 13.8394 21.8739 13.7456 21.8395 13.6423L21.6946 13.1972C21.6683 13.1237 21.6199 13.0602 21.556 13.0153C21.4921 12.9705 21.4158 12.9465 21.3378 12.9468C21.2586 12.9464 21.1813 12.971 21.1168 13.017C21.0524 13.063 21.004 13.128 20.9785 13.203L20.8323 13.6506C20.798 13.7507 20.7414 13.8418 20.6669 13.9171C20.5924 13.9923 20.5018 14.0497 20.402 14.085L19.9569 14.2291C19.8825 14.2554 19.8182 14.3042 19.7729 14.3687C19.7276 14.4333 19.7036 14.5104 19.7042 14.5892C19.7048 14.6681 19.7299 14.7448 19.7762 14.8087C19.8224 14.8726 19.8875 14.9204 19.9622 14.9456L20.4003 15.0881C20.5038 15.1226 20.5978 15.1808 20.6748 15.258C20.7518 15.3352 20.8098 15.4293 20.8442 15.5328L20.9888 15.9762C21.0146 16.0501 21.0627 16.115 21.1267 16.1606ZM20.528 14.6959L20.177 14.5871L20.5317 14.4718C20.6938 14.4159 20.8406 14.3233 20.9608 14.2012C21.0807 14.078 21.1711 13.9302 21.2253 13.7676L21.3341 13.4149L21.4491 13.7688C21.5035 13.9331 21.5957 14.0824 21.7182 14.2046C21.8407 14.3269 21.9901 14.4188 22.1545 14.473L22.5158 14.5834L22.1627 14.6984C21.9982 14.7527 21.8487 14.8448 21.7262 14.9673C21.6036 15.0898 21.5116 15.2393 21.4573 15.4038L21.3485 15.7557L21.2339 15.403C21.1797 15.2382 21.0876 15.0884 20.9651 14.9657C20.8425 14.843 20.6928 14.7503 20.528 14.6959Z"
        fill={color}
      />
      <path
        d="M16.4201 12.9468V11.2101C16.4201 10.6578 15.9724 10.2101 15.4201 10.2101H3.18933C2.63705 10.2101 2.18933 10.6578 2.18933 11.2101V19.6095C2.18933 20.1618 2.63705 20.6095 3.18933 20.6095H14.7781"
        stroke={color}
        strokeLinecap="round"
      />
      <rect
        x="4.37872"
        y="12.9468"
        width="2.18935"
        height="2.18935"
        stroke={color}
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <rect
        x="4.37872"
        y="15.1361"
        width="2.18935"
        height="2.18935"
        stroke={color}
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <rect
        x="6.56805"
        y="15.1361"
        width="2.18935"
        height="2.18935"
        stroke={color}
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <rect
        x="6.56805"
        y="12.9468"
        width="2.18935"
        height="2.18935"
        stroke={color}
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <path
        d="M18.1469 13.3559C18.2803 12.9653 20.8812 5.51866 20.8984 5.47021C20.9303 5.37981 20.9969 5.30576 21.0836 5.26434C21.1703 5.22293 21.27 5.21753 21.3608 5.24935C21.4515 5.28116 21.5259 5.34759 21.5675 5.434C21.6091 5.52041 21.6146 5.61974 21.5828 5.71014C21.4225 6.17768 18.9197 13.3338 18.825 13.6059M16.1567 19.0547C16.4013 18.6661 16.8417 18.036 17.0789 17.6589C16.7741 17.9357 16.2346 18.6509 15.9417 18.9269C15.4103 18.6752 14.8999 18.3815 14.4155 18.0486C15.1606 17.7258 15.8283 17.249 16.3743 16.6496C15.6944 17.1636 14.9284 17.5534 14.1117 17.8007C13.7314 17.4467 13.375 17.068 13.0449 16.6671C14.8353 16.7993 16.5514 15.7631 17.4613 14.3581C17.8207 14.4815 18.1831 14.5956 18.5484 14.7003C18.7508 14.7576 18.9214 14.8939 19.021 15.0787C19.6523 16.1037 19.6006 17.1249 19.0202 18.1461C18.7777 18.5732 18.4184 19.2243 18.053 19.5529C17.4033 19.463 16.7666 19.2955 16.1567 19.0547Z"
        stroke={color}
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="path-12-inside-2_3445_71" fill="white">
        <rect
          x="17.6341"
          y="13.1886"
          width="1.73733"
          height="1.10881"
          rx="0.2"
          transform="rotate(19.1804 17.6341 13.1886)"
        />
      </mask>
      <rect
        x="17.6341"
        y="13.1886"
        width="1.73733"
        height="1.10881"
        rx="0.2"
        transform="rotate(19.1804 17.6341 13.1886)"
        stroke={color}
        strokeWidth="0.6"
        mask="url(#path-12-inside-2_3445_71)"
      />
      <circle cx="19.5278" cy="20.4722" r="0.5" fill={color} stroke={color} strokeWidth="0.0555556" />
      <circle cx="20.5833" cy="18.3612" r="0.5" fill={color} stroke={color} strokeWidth="0.0555556" />
      <circle cx="20.8472" cy="19.6805" r="0.263889" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_3445_71">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

CleaningIncluded.propTypes = {
  color: PropTypes.string
};

export default CleaningIncluded;
